import styled from "styled-components";
import {validateField} from "../../utils/validation";
import {media} from "../../theme/responsive";

export const CommonFieldStyled = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: ${(props) => {
        if (validateField(props, "object", "commonFieldStyle.mobile.width"))
            return props.commonFieldStyle.mobile.width;
        return "100%";
    }};
    position: relative;
    ${media.laptop`  width: ${(props) => {
        if (validateField(props, "object", "commonFieldStyle.laptop.width"))
            return props.commonFieldStyle.laptop.width;
        return "100%";
    }};
    `}
`;

export const CommonFieldLabel = styled.label`
    font-weight: normal;
    // order: 1;
    // pointer-events: none;
    text-shadow: none;
    text-transform: capitalize;
    transform-origin: left top;
    transition: 150ms ease all;
    text-align: left;
    font-size: 0.9375rem;
    line-height: 21.12px;
`;
